import { render, staticRenderFns } from "./SmartBox.vue?vue&type=template&id=72aa59e4&scoped=true"
import script from "./SmartBox.vue?vue&type=script&lang=js"
export * from "./SmartBox.vue?vue&type=script&lang=js"
import style0 from "./SmartBox.vue?vue&type=style&index=0&id=72aa59e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aa59e4",
  null
  
)

export default component.exports